import { useState } from "react";
import { Check, Eye, EyeSlash, X } from "@phosphor-icons/react";

export const passwordChecks = (pw) => [
  { label: "At least 8 characters", ok: (pw || "").length >= 8 },
  { label: "Contains a letter", ok: /[A-Za-z]/.test(pw || "") },
  { label: "Contains a number", ok: /\d/.test(pw || "") },
];

export const passwordStrong = (pw) => passwordChecks(pw).every((c) => c.ok);

export function PasswordField({ label, value, onChange, testId, placeholder }) {
  const [show, setShow] = useState(false);
  return (
    <div className="space-y-1.5">
      <label className="label-caps">{label}</label>
      <div className="relative">
        <input type={show ? "text" : "password"} value={value ?? ""} placeholder={placeholder}
          data-testid={testId} onChange={(e) => onChange(e.target.value)}
          autoComplete="new-password" className="glass-input pr-10" />
        <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow(!show)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-white transition-colors duration-200">
          {show ? <EyeSlash size={16} /> : <Eye size={16} />}
        </button>
      </div>
    </div>
  );
}

export function PasswordStrength({ password, testId }) {
  if (!password) return null;
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1" data-testid={testId}>
      {passwordChecks(password).map((c) => (
        <span key={c.label}
          className={`flex items-center gap-1 text-[10px] font-medium ${c.ok ? "text-emerald-400" : "text-zinc-500"}`}>
          {c.ok ? <Check size={11} weight="bold" /> : <X size={11} weight="bold" />} {c.label}
        </span>
      ))}
    </div>
  );
}
